module.exports = __webpack_public_path__ + "static/img/children2.30b23d4f.jpg";